import React from "react";
import bg_img from "../../Assets/Images/OurService_bg.png";
import { Link } from "react-router-dom";

const ServiceSkeleton = () => (
  <div className="bg-white rounded-lg overflow-hidden shadow-md animate-pulse">
    <div className="w-full h-[300px] bg-gray-300"></div>
    <div className="bg-black py-3">
      <div className="mx-auto h-4 w-1/2 bg-gray-400 rounded"></div>
    </div>
  </div>
);

const OurService = ({ services = [], loading = false }) => {
  return (
    <>
      <div className="py-10">
        <div
          style={{
            backgroundImage: `url(${bg_img})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className="bg-[#F8FBFF] py-10 px-4 md:px-10"
        >
          {/* Top Text */}
          <div className="text-center mb-8">
            <p className="text-[#E8471B] font-montserrat font-medium text-[20px] leading-[24px] tracking-[0.5px] align-middle capitalize">
              Our Services
            </p>
            <h2 className="font-orbitron mt-4 font-semibold text-[45px] leading-[130%] tracking-[1px] align-middle capitalize">
              Explore Our Services
            </h2>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {loading
              ? Array(4)
                  .fill(0)
                  .map((_, idx) => <ServiceSkeleton key={idx} />)
              : services.map((service) => (
                  <Link to={`/our-services/${service._id}`} key={service._id}>
                    <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300">
                      <img
                        src={service.images?.[0]}
                        alt={service.name || "Service image"}
                        className="w-full h-[300px] object-cover"
                      />
                      <div className="bg-black text-white text-center py-3">
                        <p className="font-orbitron text-[16px] tracking-[0.5px] capitalize">
                          {service.name}
                        </p>
                      </div>
                    </div>
                  </Link>
                ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default OurService;
